namespace Nobox.NoBoxCRM {
    export interface FormRow {
        Id?: number;
        Name?: string;
        ProductId?: number;
        Product?: string;
        Results?: string;
        Type?: FormTypeEnum;
        SuccessType?: FormSuccessTypeEnum;
        SuccessData?: string;
        TagIds?: string;
        Data?: string;
        Payment?: string;
        Layout?: FormLayoutEnum;
        HLogo?: string;
        HData?: string;
        BData?: string;
        Btxt?: string;
        ShowLabel?: number;
        ShowCaptcha?: number;
        ShowCoupon?: number;
        IsSendWa?: number;
        IsSendURL?: number;
        DataSendURL?: string;
        accWa?: number;
        toWa?: string;
        IsSendMail?: number;
        accMail?: number;
        toMail?: string;
        DataWa?: string;
        DataMail?: string;
        FollowUp?: string;
        VideoUrl?: string;
        In?: string;
        Up?: string;
        InBy?: number;
        UpBy?: number;
    }

    export namespace FormRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'NoBoxCRM.Form';
        export const lookupKey = 'NoBoxCRM.Form';

        export function getLookup(): Q.Lookup<FormRow> {
            return Q.getLookup<FormRow>('NoBoxCRM.Form');
        }
        export const deletePermission = 'ProductTags:Delete';
        export const insertPermission = 'ProductTags:Modify';
        export const readPermission = 'ProductTags:View';
        export const updatePermission = 'ProductTags:Modify';

        export declare const enum Fields {
            Id = "Id",
            Name = "Name",
            ProductId = "ProductId",
            Product = "Product",
            Results = "Results",
            Type = "Type",
            SuccessType = "SuccessType",
            SuccessData = "SuccessData",
            TagIds = "TagIds",
            Data = "Data",
            Payment = "Payment",
            Layout = "Layout",
            HLogo = "HLogo",
            HData = "HData",
            BData = "BData",
            Btxt = "Btxt",
            ShowLabel = "ShowLabel",
            ShowCaptcha = "ShowCaptcha",
            ShowCoupon = "ShowCoupon",
            IsSendWa = "IsSendWa",
            IsSendURL = "IsSendURL",
            DataSendURL = "DataSendURL",
            accWa = "accWa",
            toWa = "toWa",
            IsSendMail = "IsSendMail",
            accMail = "accMail",
            toMail = "toMail",
            DataWa = "DataWa",
            DataMail = "DataMail",
            FollowUp = "FollowUp",
            VideoUrl = "VideoUrl",
            In = "In",
            Up = "Up",
            InBy = "InBy",
            UpBy = "UpBy"
        }
    }
}
